module.exports = __webpack_public_path__ + "img/regensburg_maison.55928979.jpg";